import { Descope } from '@descope/react-sdk';
import { SIGN_IN_FLOW_ID } from '../config/auth';
import { SignInContent, SignInPageContainer } from './SignInPage.styled';

export function SignInPage() {
  return (
    <SignInPageContainer>
      <SignInContent>
        <Descope flowId={SIGN_IN_FLOW_ID} />
      </SignInContent>
    </SignInPageContainer>
  );
}
